import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spinner } from "reactstrap";
import ReusableCard from "./Reusable";
import "./CSS/StationWiseData.css";
import { Link } from "react-router-dom";
import moment from "moment";
import { getDashboardData } from "./API/Api";
import _ from "underscore";
import { useLocation } from "react-router-dom";
//TitLe card
const TitleCard = ({ title }) => {
  return (
    //  <Card className="p-1 info_widget justify-content-center ReusableCard">
    <Row className="text-center">
      <Col>
        <span className="fs-3">{title}</span>
      </Col>
    </Row>
    // </Card>
  );
};

const Home = () => {
  const [result, setResult] = useState();
  const [ebmResponse, setEBMResponse] = useState();
  const [ubsResponse, setUBSResponse] = useState();
  const [cssResponse, setCSSResponse] = useState();
  const location = useLocation();
  const [showAccessDenied, setShowAccessDenied] = useState(true);
  const [EMBloading, setEBMLoading] = useState(true);
  const [UBSLoading, setUBSLoading] = useState(true);
  const [CSSLoading, setCSSLoading] = useState(true);
  const params = new URLSearchParams(location.search);
  useEffect(() => {}, []);
  const handleCardClick = (title) => {
    sessionStorage.setItem("selectedTitle", title); 
  };

  //

  const fetchData = async () => {
    try {
      const EBM_response = await getDashboardData("K#EBM");

      // const groupedByStation = _.groupBy(response, "station");
      setEBMResponse(EBM_response);
      setEBMLoading(false);
      const UBS_response = await getDashboardData("K#UBS");
      setUBSResponse(UBS_response);
      setUBSLoading(false);
      const CSS_response = await getDashboardData("K#CSS");
      setCSSResponse(CSS_response);
      setCSSLoading(false);
      // setCSSResponse(groupedByStation["K#CSS"]);
      // console.log(groupedByStation, ebmResponse, ubsResponse, cssResponse);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    let user = params.get("user");
    let pwd = params.get("pwd");

    if (user && pwd) {
      console.log(user, pwd);
      sessionStorage.setItem("user", user);
      sessionStorage.setItem("pwd", pwd);
      setShowAccessDenied(false);
      fetchData();
    }
  }, []);
  return (
    <div className="text-center">
      {showAccessDenied ? (
        <>
          {" "}
          <Row className="justify-content-center text-center">
            <h4 className="access-denied-text">Access Denied</h4>
          </Row>
        </>
      ) : (
        <>
          <Row className="justify-content-center">
            <Col>
              <span className="fs-3">
                Date: {moment().startOf("month").format("DD/MM/YYYY")} -{" "}
                {moment(new Date()).format("DD/MM/YYYY")}
              </span>
            </Col>
          </Row>
          <div className="container mt-4">
            <Row>
              <Col xs={12} sm={6} md={4}>
                <Link
                  to="/stations"
                  className="text-decoration-none custom-link"
                  onClick={() => handleCardClick("EBM")}
                >
                  <Card className="p-1 info_widget justify-content-center ReusableCard">
                    {EMBloading ? (
                      // Display the Spinner while loading
                      <Spinner color="primary" />
                    ) : (
                      <>
                        <TitleCard title="Exposed Bare Metal" />
                        {ebmResponse &&
                          ebmResponse.map((i, key) => (
                            <ReusableCard
                              key={key}
                              shift={i.shift}
                              totalNoOfVehicles={i.vehicle_count}
                              okayVehicles={i.ok_vehicle_count}
                              okayVehiclesColor="green-color"
                              vehiclesWithDefects={i.defect_count}
                              vehiclesWithDefectsColor="red-color"
                            />
                          ))}
                      </>
                    )}
                  </Card>
                </Link>
              </Col>
              <Col xs={12} sm={6} md={4}>
                <Link
                  to="/stations"
                  className="text-decoration-none custom-link"
                  onClick={() => handleCardClick("UBS")}
                >
                  <Card className="p-1 info_widget justify-content-center ReusableCard">
                    {UBSLoading ? (
                      // Display the Spinner while loading
                      <Spinner color="primary" />
                    ) : (
                      <>
                        <TitleCard title="Underbody Seam Sealant" />
                        {ubsResponse &&
                          ubsResponse.map((i, key) => (
                            <ReusableCard
                              key={key}
                              shift={i.shift}
                              totalNoOfVehicles={i.vehicle_count}
                              okayVehicles={i.ok_vehicle_count}
                              okayVehiclesColor="green-color"
                              vehiclesWithDefects={i.defect_count}
                              vehiclesWithDefectsColor="red-color"
                            />
                          ))}
                      </>
                    )}
                  </Card>
                </Link>
              </Col>
              <Col xs={12} sm={6} md={4}> 
                 <Link
                  to="/stations"
                  className="text-decoration-none custom-link"
                  onClick={() => handleCardClick("CSS")}
                >
                  <Card className="p-1 info_widget justify-content-center ReusableCard">
                    {CSSLoading ? (
                      // Display the Spinner while loading
                      <Spinner color="primary" />
                    ) : (
                      <>
                        <TitleCard title="Cosmetic Seam Sealant" />
                        {cssResponse &&
                          cssResponse.map((i, key) => (
                            <ReusableCard
                              key={key}
                              shift={i.shift}
                              totalNoOfVehicles={i.vehicle_count}
                              okayVehicles={i.ok_vehicle_count}
                              okayVehiclesColor="green-color"
                              vehiclesWithDefects={i.defect_count}
                              vehiclesWithDefectsColor="red-color"
                            />
                          ))}
                      </>
                    )}
                  </Card>
                </Link>
              </Col>
            </Row>
          </div>
        </>
      )}{" "}
      {/* </>
      )} */}
    </div>
  );
};

export default Home;
